
import React, {FC} from 'react';
import Button from 'components/Button';

import * as styles from './styles.module.scss';

type ErrorProps = {
	error: string
	onExit: () => void
}

const Error: FC<ErrorProps> = ({error, onExit}) => (
	<div className={styles.wrapper}>
		<div>
			<p>We ran into an error processing your request.</p>
			<p>{error}</p>
		</div>
		<Button variant='light' onClick={onExit}>
			Close
		</Button>
	</div>
);

export default Error;
